import * as materials from "materials/legacy/legacy-normal";
export { materials };
export default materials;
